/**
 * AS GRAVIDADES DA OCORRÊNCIA — uma lista só (spec 0074, AC-6).
 *
 * Até 05/10/2026 a ficha tinha a própria lista (baixa, média, alta), e o servidor
 * só aceita `informacao`, `leve`, `media` e `grave` (`services/fiscalizacao.py`):
 * escolher Baixa ou Alta na ficha era sempre recusado. A tela de Fiscalização já
 * usava os valores certos. As duas leem daqui.
 */
export const GRAVIDADES_DA_OCORRENCIA = [
  { valor: "informacao", rotulo: "Informação" },
  { valor: "leve", rotulo: "Leve" },
  { valor: "media", rotulo: "Média" },
  { valor: "grave", rotulo: "Grave" },
] as const

/** A gravidade com que um registro novo começa. */
export const GRAVIDADE_INICIAL = "leve"
